<template>
    <div class="form-item button" :class="[item.data.htmloptions]">
        <button type="submit" :class="['btn btn-primary', { 'btn--loading' : this.loader, 'btn--success' : this.success }]" @click.prevent="onSubmit">
            <span v-if="!loader">{{ genLabel }}</span>
            <span v-else class="spinner-border"></span>
            <i v-if="success" class="icon-form-checkmark"></i>
        </button>
    </div>
</template>

<script>
import eventBus from "../../formeditor/util/EventBus";

export default {
    name: 'Button',
    props: {
        item: {
            type: Object
        },
        errors: {
            type: Object
        },
        btnLabel: {
            type: String
        }
    },
    data: function () {
        return {
            loader: false,
            success: false
        };
    },
    computed: {
          genLabel () {
              return this.btnLabel ?? this.item.data.buttontext
          }
    },
    methods: {
        activateLoader() {
            this.loader = true;
        },
        onSubmit() {
            this.activateLoader()
            this.$emit('submit')
        }
    },
    mounted() {
        eventBus.$on("formSuccess", () => {
            this.success = true;
            this.loader = false;
        });

        eventBus.$on("formFail", () => {
            this.loader = false;
        });
    }
};
</script>

<style lang="scss" scoped>
@import "frontend/styles/framework";

$white: #ffffff !default;
$color-success: #42a094 !default;

.btn {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
        position: absolute;
        right: 5px;
        margin-right: 0;
        font-size: 25px;
        color: $white;
    }

    &--loading {
        pointer-events: none;
        box-shadow: none !important;
    }

    &--success {
        background-color: $color-success !important;
        box-shadow: none !important;
        pointer-events: none;
    }
}

</style>